import type { WidgetProps } from '@rjsf/utils'
import { DateInputWidget } from './DateInputWidget'

export const SelectDueDateWidget = ({
  className,
  disabled,
  id,
  onChange,
  placeholder,
  readonly,
  required,
  schema,
  value = ''
}: WidgetProps) => (
  <DateInputWidget
    className={className}
    disabled={disabled}
    formatMaximum={schema.formatMaximum as string | undefined}
    formatMinimum={schema.formatMinimum as string | undefined}
    id={id}
    onChange={onChange}
    placeholder={placeholder}
    readonly={readonly}
    required={required}
    value={value}
  />
)
